// extracted by mini-css-extract-plugin
module.exports = {"power-backup-fix-tab":"FixTab_power-backup-fix-tab__BqAYh"};